import { render } from "./Advantages.vue?vue&type=template&id=70a75b25&ts=true&lang=pug"
import script from "./Advantages.vue?vue&type=script&setup=true&lang=ts"
export * from "./Advantages.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__